<script>
import { mapGetters } from 'vuex'

import Textfield from 'linna/components/Textfield'

import Led from '@/components/snippets/Led'
import StyledButton from '@/components/snippets/StyledButton'

export default {
  name: 'Notebook',

  components: {
    Led,
    StyledButton,
    Textfield
  },

  data () {
    return {
      currentNotebookPageIndex: 0
    }
  },

  computed: {

    ...mapGetters([
      'notebookPages',
      'lastNotebookPageIndex'
    ]),

    notebookContent: {

      get () {
        return this.$store.getters.notebookPageByIndex(this.currentNotebookPageIndex)
      },

      set (content) {
        this.$store.dispatch('setNotebookPageContent', {
          i: this.currentNotebookPageIndex,
          content
        })
      }

    }

  }

}
</script>

<template>
  <div class="c-notebook">
    <div class="c-notebook-content">

      <div class="c-notebook-navigation">

        <styled-button
          :disabled="currentNotebookPageIndex <= 0"
          @click="currentNotebookPageIndex--"
        >
          &lt;
        </styled-button>

        <div
          v-for="(content, i) in notebookPages"
          :key="i"
          :class="{
            'c-notebook-navigation-item-current': i === currentNotebookPageIndex
          }"
          class="c-notebook-navigation-item"
        >
          <div>
            {{ i + 1 }}
          </div>

          <led :on="i === currentNotebookPageIndex" />

        </div>

        <styled-button
          :disabled="currentNotebookPageIndex >= lastNotebookPageIndex"
          @click="currentNotebookPageIndex++"
        >
          &gt;
        </styled-button>

      </div>

      <textfield
        :multiline="true"
        :value.sync="notebookContent"
        class="c-notebook-page"
      />

    </div>
  </div>
</template>

<style lang="scss">

.c-notebook-navigation {
  @include flex;
  @include flex-center;
}

.c-notebook-page {

  .c-textfield-input {
    @include pad-even;
    border-width: 0.1rem;
  }

}

</style>
